import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { Analytics } from '@vercel/analytics/react'
import { initRevenueCat } from './services/revenueCat.js'

// Fire-and-forget — no-ops in browser, configures the SDK once on iOS.
initRevenueCat()

// Global handlers — catch anything the React tree misses (async rejections,
// errors thrown outside render). These log with a clear tag so they're easy to
// spot in the Chrome DevTools console.
window.addEventListener('error', (e) => {
  // eslint-disable-next-line no-console
  console.error('[window.error]', e.message, e.filename + ':' + e.lineno, e.error)
})
window.addEventListener('unhandledrejection', (e) => {
  // eslint-disable-next-line no-console
  console.error('[unhandledrejection]', e.reason)
})

// eslint-disable-next-line no-console
console.log('[boot] main.jsx executing — about to mount React')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
    <Analytics />
  </React.StrictMode>,
)

// eslint-disable-next-line no-console
console.log('[boot] React root render() called')
